"use client";

import { TableRow, TableCell } from "@oreme/ui";
import React, { type HTMLAttributes, type ReactElement } from "react";
import type { Timeserie } from "@/types";

interface TimeserieTableRowProps extends HTMLAttributes<HTMLDivElement> {
  timeserie: Timeserie;
}

function TimeserieTableRow({
  timeserie,
}: Readonly<TimeserieTableRowProps>): ReactElement {
  return (
    <TableRow className="text-xs">
      <TableCell className="py-2">{timeserie.name}</TableCell>
      <TableCell className="py-2">
        {timeserie.startDate?.toDateString()}
      </TableCell>
    </TableRow>
  );
}

export { TimeserieTableRow, type TimeserieTableRowProps };
